import React from 'react';
import { cn } from '@/lib/utils';
import { shortenText } from '@/lib/utils';
import type { FirestoreLocation } from '@/types/firestore';

interface LocationListItemProps {
  location: FirestoreLocation;
  isSelected: boolean;
  onClick: (locationId: string) => void;
  className?: string;
}

export const LocationListItem: React.FC<LocationListItemProps> = ({
  location,
  isSelected,
  onClick,
  className = ''
}) => {
  return (
    <button
      type="button"
      onClick={() => onClick(location.id!)}
      className={cn(
        'w-full text-left p-3 hover:bg-accent/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-md transition-colors',
        isSelected && 'bg-accent text-accent-foreground',
        className
      )}
      aria-pressed={isSelected}
    >
      <div className="font-medium text-sm truncate">{location.name}</div>
      {location.address && (
        <div className={cn(
          'text-xs truncate',
          isSelected ? 'text-accent-foreground/80' : 'text-muted-foreground'
        )}>
          {shortenText(location.address, 35)} 
        </div>
      )}
    </button>
  );
}; 